module.exports = __webpack_public_path__ + "img/sonya.3047794.webp";